import { useEffect, useCallback } from "react";
import Win2kButton from "@/components/win2k/Win2kButton";

interface ForceSkipDialogProps {
  username: string;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ForceSkipDialog({
  username,
  open,
  onConfirm,
  onCancel,
}: ForceSkipDialogProps) {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onCancel();
    },
    [onCancel]
  );

  useEffect(() => {
    if (open) {
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    }
  }, [open, handleKeyDown]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="win2k-outset bg-[var(--win2k-window-bg)] max-w-xs w-full mx-4">
        <div className="win2k-title-bar px-1 py-0.5 min-h-[22px]">
          <span className="text-xs font-bold">Flip 7</span>
        </div>
        <div className="p-4 space-y-4">
          <p className="text-[12px] text-[var(--win2k-button-text)]">
            Force skip <strong>{username}</strong>&apos;s turn?
            They will be busted with 0 points for this round.
          </p>
          <div className="flex justify-end gap-2">
            <Win2kButton onClick={onConfirm} className="min-w-[75px]">
              Force Skip
            </Win2kButton>
            <Win2kButton
              onClick={onCancel}
              className="min-w-[75px]"
              autoFocus
            >
              Cancel
            </Win2kButton>
          </div>
        </div>
      </div>
    </div>
  );
}
